'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
const CANT_FIND_LIB_BY_NAME = exports.CANT_FIND_LIB_BY_NAME = 'CANT_FIND_LIB_BY_NAME';
const CANT_GET_LIB_XODBALL = exports.CANT_GET_LIB_XODBALL = 'CANT_GET_LIB_XODBALL';
const CANT_FIND_LIB_VERSION = exports.CANT_FIND_LIB_VERSION = 'CANT_FIND_LIB_VERSION';
const CANT_PARSE_LIBRARY_REQUEST = exports.CANT_PARSE_LIBRARY_REQUEST = 'CANT_PARSE_LIBRARY_REQUEST';
const INVALID_XODBALL = exports.INVALID_XODBALL = 'INVALID_XODBALL';
const SERVICE_UNAVAILABLE = exports.SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE';
const CANT_GET_SWAGGER = exports.CANT_GET_SWAGGER = 'CANT_GET_SWAGGER';


//////////////////
// WEBPACK FOOTER
// ../xod-pm/dist/errorCodes.js
// module id = 359
// module chunks = 0